import React from 'react';
import styles from './SignIn.module.scss';
import { CustomerSelect } from '../CustomerSelect/CustomerSelect';
import Logo from '../../common/Logo/Logo';
import SignInForm from '../SignInForm/SignInForm';
import { IAuthTokens, IAuthUser } from '../../../types';
import AuthCard from '../AuthCard/AuthCard';

type SignInProps = {
    tokens: IAuthTokens[];
    isLogged: boolean;
    isLoading: boolean;
    onSubmit: (user: IAuthUser) => void;
    logo?: string;
};

export default function SignIn(props: SignInProps) {
    const { tokens, isLoading, isLogged, onSubmit, logo } = props;

    if (tokens && !isLogged) {
        return <CustomerSelect tokens={tokens} />;
    }

    return (
        <AuthCard
            isLoading={isLoading}
            header={<div className={styles.header}>{logo || <Logo />}</div>}
        >
            <SignInForm onSubmit={onSubmit} />
        </AuthCard>
    );
}
